// import React, { useEffect, useState, useRef } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import Header from "../Header";
// import Loader from "../Utils/Loader";
// import {
//   Userlogin,
//   GetDealerdata,
//   Toast,
//   shareIphonePostMsg,
// } from "../Utils/general-function";
// import html2canvas from "html2canvas";

// function AllImages(props) {
//   const [loading, setLoading] = useState(true);
//   const [images, setImages] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedcategory, setSelectedcategory] = useState(0);
//   const [Display, setDisplay] = useState("inline-block");
//   const navigate = useNavigate();
//   const countRef = useRef(1);
//   const mount = useRef(true);
//   const iphone = window.navigator.userAgent.includes("Mac");

//   const header = {
//     headers: {
//       Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
//     },
//   };

//   useEffect(() => {
//     if (!Userlogin()) {
//       navigate("/Login");
//       return;
//     }

//     const fetchdatasync = async () => {
//       // const Dealerdata = await GetDealerdata();
//       // if ((Dealerdata.nCity === "")) {
//       //   Toast(false, "", "Please Complete your Profile");
//       //   navigate("/Profile");
//       //   return;
//       // }
//       if (mount.current) {
//         fetchAllImages(0);
//         mount.current = false;
//         fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/categorydata")
//           .then((response) => response.json())
//           .then((res) => {
//             setCategories(res.Data);
//           })
//           .catch((error) => console.error("Error fetching categories:", error));
//       }
//     };
//     fetchdatasync();
//   }, []);

//   const fetchAllImages = async (category) => {
//     setLoading(true);

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/UploadImages/AllUploadContentImages?pageindex=${countRef.current}&categoryid=${category}`,
//         header
//       );
//       const res = await response.json();
//       setDisplay("inline-block");
//       if (res.Success) {
//         countRef.current === 1
//           ? setImages(res.Data)
//           : setImages((prevImages) => [...prevImages, ...res.Data]);
//         countRef.current += 1; // Increment index after fetching
//       }
//       if (!res.Data || res.Data.length < 6) {
//         setDisplay("none");
//       }
//     } catch (error) {
//       console.error("Exception found:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const onChange = (e) => {
//     setSelectedcategory(e.target.value);
//     countRef.current = 1;
//     fetchAllImages(e.target.value);
//   };

//   const DownloadImg = async (randomid, name) => {
//     setLoading(true);
//     await fetch(
//       process.env.REACT_APP_API_ENDPOINT +
//         "/api/FrameMaster/DownloadFrame?imagerandomid=" +
//         randomid,
//       header
//     )
//       .then((response) => response.json())
//       .then(async (res) => {
//         const input = document.getElementById("pic");
//         input.innerHTML = await res.Data.FrameData;
//         input.style.display = "block";

//         html2canvas(input, {
//           useCORS: true,
//         })
//           .then(async (canvas) => {
//             const imgData = await canvas.toDataURL("image/jpeg");

//             if (iphone) {
//               return shareIphonePostMsg({
//                 data: imgData,
//                 action: "downloadBs64Media",
//                 filename: name,
//               });
//             }
//             let a = document.createElement("a");
//             document.body.appendChild(a);
//             a.href = imgData;
//             a.download = name;
//             a.click();

//             input.style.display = "none";
//             setLoading(false);
//           })
//           .catch((err) => {
//             console.log(err);
//             setLoading(false);
//           })
//           .finally(() => {
//             setLoading(false);
//             input.style.display = "none";
//           });
//       });
//   };

//   return (
//     <div>
//       <Header />
//       <Link
//         to="/allframe"
//         className="sharebtn sharbtnpos"
//         style={{ padding: "8px" }}
//       >
//         Change Frame
//       </Link>
//       {loading && <Loader />}
//       <div className="page-space">
//         <div className="form-div">
//           <select
//             className="form-select form-control"
//             name="selectedcategory"
//             // value={selectedcategory}
//             onChange={onChange}
//             defaultValue=""
//           >
//             <option value="" disabled={true}>
//               Choose a Category
//             </option>
//             <option value="0">All</option>
//             {categories.map((list, i) => (
//               <option value={list.Value} key={i}>
//                 {list.Text}
//               </option>
//             ))}
//           </select>
//         </div>
//         {images.length === 0 ? (
//           <div className="text-center">
//             <h4
//               style={{
//                 margin: "20px auto",
//                 fontSize: "20px",
//                 color: "#ff1237",
//               }}
//             >
//               No Record Found
//             </h4>
//           </div>
//         ) : (
//           <>
//             <div className="car-grid">
//               {images.map((data) => (
//                 <div className="grt-imgdiv" key={data.random}>
//                   <div className="grt-reldiv">
//                     <img
//                       src={data.imageupload}
//                       alt="Carthi"
//                       className="img-fluid"
//                       style={{ borderRadius: "4px" }}
//                     />
//                     <div className="get-absdiv">
//                       <h6 className="mt-2">{data.title}</h6>
//                     </div>
//                   </div>
//                   <button
//                     className="submitbtn"
//                     onClick={(e) =>
//                       DownloadImg(data.random, data.imageuploadname)
//                     }
//                   >
//                     Download
//                   </button>
//                 </div>
//               ))}
//             </div>
//             <div className="text-center pt-3 mb-3">
//               <button
//                 type="submit"
//                 className="submitbtn"
//                 style={{ display: Display }}
//                 onClick={(e) => fetchAllImages(selectedcategory)}
//               >
//                 Load More
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//       <div id="pic" style={{ width: "1080px" }}></div>
//     </div>
//   );
// }

// export default AllImages;

// // new one with sub category
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../Header";
import Loader from "../Utils/Loader";
import Select from "react-select";

import {
  Userlogin,
  GetDealerdata,
  Toast,
  shareIphonePostMsg,
  handlePostApiGF,
  handleGetApiGF,
} from "../Utils/general-function";
import html2canvas from "html2canvas";

function AllImages(props) {
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [selectedcategory, setSelectedcategory] = useState(0);
  const [subSelectedcategoryObj, setSubSelectedcategoryObj] = useState(null); // image title
  const [Display, setDisplay] = useState("inline-block");
  const navigate = useNavigate();
  const countRef = useRef(1);
  const mount = useRef(true);
  const iphone = window.navigator.userAgent.includes("Mac");

  const header = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
    },
  };
  const fetchSubCqtegories = async ({ category }) => {
    const res = await handleGetApiGF({
      url: "/api/UploadImages/AllUploadContentTitlebyID?categoryid=" + category,
    });
    console.log("res", res);
    setSubCategories(res.data.Data || []);
  };
  useEffect(() => {
    if (!Userlogin()) {
      navigate("/Login");
      return;
    }
    const fetchdatasync = async () => {
      // const Dealerdata = await GetDealerdata();
      // if ((Dealerdata.nCity === "")) {
      //   Toast(false, "", "Please Complete your Profile");
      //   navigate("/Profile");
      //   return;
      // }
      if (mount.current) {
        fetchAllImages({ category: selectedcategory, contenttitle: "" });
        fetchSubCqtegories({ category: selectedcategory });
        mount.current = false;
        fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/categorydata")
          .then((response) => response.json())
          .then((res) => {
            setCategories(res.Data);
          })
          .catch((error) => console.error("Error fetching categories:", error));
      }
    };
    fetchdatasync();
  }, []);

  const fetchAllImages = async ({ category, contenttitle }) => {
    setLoading(true);
    try {
      let obj = {
        pageindex: countRef.current,
        categoryid: category,
        contenttitle: contenttitle || "",
      };
      let params = new URLSearchParams(obj).toString();
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/UploadImages/AllUploadContentImagesbycategoryandtitle?${params}`,
        header
      );
      const res = await response.json();
      setDisplay("inline-block");
      if (res.Success) {
        countRef.current === 1
          ? setImages(res.Data)
          : setImages((prevImages) => [...prevImages, ...res.Data]);
        countRef.current += 1; // Increment index after fetching
      } else if (!res.Success && countRef.current === 1) {
        setImages([]);
      }
      if (!res.Data || res.Data.length < 6) {
        setDisplay("none");
      }
    } catch (error) {
      console.error("Exception found:", error);
    } finally {
      setLoading(false);
    }
  };

  const onChange = (e) => {
    setSelectedcategory(e.target.value);
    setSubSelectedcategoryObj(null);
    countRef.current = 1;
    fetchAllImages({ category: e.target.value, contenttitle: "" });
    fetchSubCqtegories({ category: e.target.value });
  };
  const onSubChange = (e) => {
    console.log("e", e);

    setSubSelectedcategoryObj(e);
    countRef.current = 1;
    fetchAllImages({ category: selectedcategory, contenttitle: e?.Text || "" });
  };
  const DownloadImg = async (randomid, name) => {
    setLoading(true);
    await fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/FrameMaster/DownloadFrame?imagerandomid=" +
        randomid,
      header
    )
      .then((response) => response.json())
      .then(async (res) => {
        const input = document.getElementById("pic");
        input.innerHTML = await res.Data.FrameData;
        input.style.display = "block";

        html2canvas(input, {
          useCORS: true,
        })
          .then(async (canvas) => {
            const imgData = await canvas.toDataURL("image/jpeg");

            if (iphone) {
              return shareIphonePostMsg({
                data: imgData,
                action: "downloadBs64Media",
                filename: name,
              });
            }
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.href = imgData;
            a.download = name;
            a.click();

            input.style.display = "none";
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          })
          .finally(() => {
            setLoading(false);
            input.style.display = "none";
          });
      });
  };
  console.log("subcategories", subcategories);
  console.log("subSelectedcategoryObj", subSelectedcategoryObj);

  return (
    <div>
      <Header />
      <Link
        to="/allframe"
        className="sharebtn sharbtnpos"
        style={{ padding: "8px" }}
      >
        Change Frame
      </Link>
      {loading && <Loader />}
      <div className="page-space">
        <div className="form-div">
          <select
            className="form-select form-control"
            name="selectedcategory"
            // value={selectedcategory}
            onChange={onChange}
            defaultValue=""
          >
            <option value="" disabled={true}>
              Choose a Category
            </option>
            <option value="0">All</option>
            {categories.map((list, i) => (
              <option value={list.Value} key={i}>
                {list.Text}
              </option>
            ))}
          </select>
        </div>
        <div className="form-div">
          <Select
            placeholder="--Select Image Title--"
            name="company"
            options={subcategories}
            value={subSelectedcategoryObj}
            getOptionLabel={(option) => option.Text}
            getOptionValue={(option) => option.Text}
            onChange={(e) => onSubChange(e)}
            closeMenuOnSelect={true}
            blurInputOnSelect={false}
            isSearchable={true}
            // styles={customStyles}
          ></Select>

          {/* <span className="text-danger">{errors.company}</span> */}
        </div>
        {images.length === 0 ? (
          <div className="text-center">
            <h4
              style={{
                margin: "20px auto",
                fontSize: "20px",
                color: "#ff1237",
              }}
            >
              No Record Found
            </h4>
          </div>
        ) : (
          <>
            <div className="car-grid">
              {images.map((data) => (
                <div className="grt-imgdiv" key={data.random}>
                  <div className="grt-reldiv">
                    <img
                      src={data.imageupload}
                      alt="Carthi"
                      className="img-fluid"
                      style={{ borderRadius: "4px" }}
                    />
                    <div className="get-absdiv">
                      <h6 className="mt-2">{data.title}</h6>
                    </div>
                  </div>
                  <button
                    className="submitbtn"
                    onClick={(e) =>
                      DownloadImg(data.random, data.imageuploadname)
                    }
                  >
                    Download
                  </button>
                </div>
              ))}
            </div>
            <div className="text-center pt-3 mb-3">
              <button
                type="submit"
                className="submitbtn"
                style={{ display: Display }}
                onClick={(e) =>
                  fetchAllImages({
                    category: selectedcategory,
                    contenttitle: subSelectedcategoryObj?.Text || "",
                  })
                }
              >
                Load More
              </button>
            </div>
          </>
        )}
      </div>
      <div id="pic" style={{ width: "1080px" }}></div>
    </div>
  );
}

export default AllImages;
